module.exports = __webpack_public_path__ + "img/settlementSettings.6bdc52d3.svg";